const initialState = {
  formData: null,
  isError: false,
  submitRes: null,
};

export const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_QUESTIONS_SUCCESS":
      return {
        ...state,
        formData: action.payload.data,
        isError: false,
      };
    case "GET_QUESTIONS_FAIL":
      return {
        ...state,
        isError: true,
      };
    case "SUBMIT_FORM_SUCCESS":
      return {
        ...state,
        submitRes: action.payload.data,
        isError: false,
      };
    case "SUBMIT_FORM_FAIL":
      return {
        ...state,
        isError: true,
      };
    default:
      return state;
  }
}
